import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootStyle: {
      '& > * + *': {
        marginLeft: `${theme.spacing(1.5)}px !important`,
      },
    },
    entityBtn: {
      textTransform: 'none',
    },
    entityBtnActive: {
      textTransform: 'none',
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  }),
);
